import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchAccessPoint } from 'store/actions/accessPoints/fetchAccessPoints';
import AccessPointShow from './AccessPointShow';
import fetchResourceById from 'components/hoc/fetchResourceById';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { fetchProduct } from 'store/actions/products/fetchProducts';

class AccessPointShowContainer extends Component {
    componentDidMount() {
        if (this.props.productId) {
            const { fetchAccessPointProduct, productId } = this.props;

            fetchAccessPointProduct(productId);
        }
    }

    render() {
        const {
            data,
            history,
            id,
            location,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
            product,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed || !data) {
            return <ResourceNotFound />;
        }

        return <AccessPointShow
            history={ history }
            id={ id }
            location={ location }
            product={ product }
            record={ data }
            resource={ resource }
        />;
    }
}

AccessPointShowContainer.propTypes = {
    data: PropTypes.object,
    fetchAccessPointProduct: PropTypes.func,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    location: PropTypes.object.isRequired,
    productId: PropTypes.string,
    product: PropTypes.object,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, props) => {

    return {
        product: props.productId ? state.products.data[props.productId] : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAccessPointProduct: (id) => {
            dispatch(fetchProduct({
                id: id,
            }));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    fetchResourceById({
        action: fetchAccessPoint,
        resource: 'access-points',
    })
);

export default enhance(AccessPointShowContainer);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/show/AccessPointShowContainer.js